import script from "./EmbarquesValidacaoLpcoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbarquesValidacaoLpcoForm.vue?vue&type=script&setup=true&lang=js"

import "./EmbarquesValidacaoLpcoForm.vue?vue&type=style&index=0&id=777ba33e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777ba33e"]])

export default __exports__